// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"ce9c6c2a","703":"0ca703fa"}[chunkId] + ".chunk.js";
};